<template>
  <div class="spinner-backdrop" v-if="isLoading">
    <div class="spinner"></div>
  </div>
  <div v-else>
    <div v-if="!settings.hasMarketingAffiliate" class="vh-100 bg-white">
      <AppInactiveAffiliate :settings="settings"></AppInactiveAffiliate>
    </div>
    <div v-else class="add-wrapper">
      <div class="wrapper d-flex flex-column bg-secondary h-100">
        <div class="header container-fluid box-shadow-high py-3 sticky-top bg-white">
          <div class="d-flex align-items-center justify-content-around">
            <img v-if="settings.logoUrl" :src="settings.logoUrl" class="img-fluid brand" :alt="settings.companyName">
            <span v-else>{{settings.companyName}}</span>
          </div>
        </div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import handleError from '../error-handler';
import AppInactiveAffiliate from '../components/AppInactiveAffiliate.vue';

export default {
  name: 'layout',
  components: { AppInactiveAffiliate },
  data() {
    return {
      id: '',
      isLoading: true,
      settings: {
        logoUrl: '',
        companyName: '',
        hasMarketingAffiliate: false,
      },
    };
  },
  computed: {

  },
  methods: {
    loadSettings() {
      axios.get([window.sm.url, `public/affiliate-settings/${this.id}`].join('/')).then((response) => {
        this.settings = response.data;
        window.sm.settings = this.settings;
        this.isLoading = false;
      }).catch((err) => {
        // eslint-disable-next-line
        alert('Unable to find your affiliate settings.  Please contact your affiliate sponsor.');
        handleError(err);
      });
    },
  },
  mounted() {
    const { id } = this.$route.params;
    this.id = id;

    this.loadSettings();
  },
};
</script>
